<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Socialguard"
      title="Socialguard"
    >

      <NotificationBell v-if="windowWidth < 992 "></NotificationBell>
      <h5 class="text-muted text-center d-none d-md-block" v-if="isAdmin">Admin</h5>
      <h5 class="text-muted text-center d-none d-md-block" v-if="isOperator">Verwaltung</h5>
      <h5 class="text-muted text-center d-none d-md-block" v-if="isService">Service</h5>
      <template slot="links">
        <sidebar-item v-if="isService"
          :link="{
            name: 'Start',
            icon: 'ni ni-tv-2 text-primary',
            path: '/service'
          }"
        />
        <sidebar-item v-else
                      :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard'
          }"
        />
        <sidebar-item v-if="(isAdmin || isOperator) && activeLocation !== null" :link="{name: 'Spieler prüfen', icon: 'fas fa-search text-primary', path: '/service/check'}"/>
        <sidebar-item v-if="!isService || (typeof locationData.isActivityAllowed !== 'undefined' && locationData.isActivityAllowed)" :link="{name: 'Spielerschutzmaßnahmen', icon: 'fas fa-tasks text-primary', path: '/activities/list'}"/>
        <sidebar-item v-if="!isService || (typeof locationData.isInspectionTourAllowed !== 'undefined' && locationData.isInspectionTourAllowed)" :link="{name: 'Kontrollgänge', icon: 'ni ni-bullet-list-67 text-primary', path: '/inspectiontours/list'}"/>
        <sidebar-item v-if="!isService || (typeof locationData.isTaskAllowed !== 'undefined' && locationData.isTaskAllowed)" :link="{name: 'Aufgaben', icon: 'ni ni-check-bold text-blue', path: '/tasks/list'}"/>
        <sidebar-item v-if="!isService || (typeof locationData.isProtocolAllowed !== 'undefined' && locationData.isProtocolAllowed)" :link="{name: 'Ausgefüllte Protokolle', icon: 'fab fa-wpforms text-primary', path: '/service/protocols'}"/>
        <sidebar-item v-if="isService && (typeof locationData.isProtocolAllowed !== 'undefined' && locationData.isProtocolAllowed)" :link="{name: 'Neues Protokoll', icon: 'fas fa-plus text-primary', path: '/service/protocols/create'}"/>
        <hr class="my-2"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'Berichte', icon: 'fas fa-file-alt text-primary', path: '/reports/list'}"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'Organisationen', icon: 'ni ni-collection text-primary', path: '/customer/list'}"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'Standorte', icon: 'ni ni-pin-3 text-primary', path: '/locations/list'}"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'Zugangsdaten', icon: 'ni ni-single-02 text-primary', path: '/users/list'}"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'Mitarbeiter-Profile', icon: 'fas fa-users text-primary', path: '/users/profiles'}"/>
        <sidebar-item v-if="!isService || locationData.isPremium" :link="{name: 'Nachweise', icon: 'fas fa-certificate text-primary', path: '/users/profiles_documents'}"></sidebar-item>
        <hr class="my-2"/>
        <sidebar-item v-if="!isService || locationData.isPremium" :link="{name: 'Dateien', icon: 'ni ni-folder-17 text-primary', path: '/documents/main'}"/>
        <!---<hr class="my-2"/>
        <li class="nav-item"><h3 class="nav-link">OASIS</h3></li> --->
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'OASIS Verwaltung', icon: 'far fa-id-badge text-primary', path: '/oasiscerts'}"/>
        <sidebar-item v-if="isAdmin || isOperator" :link="{name: 'OASIS Zertifikate', icon: 'far fa-id-badge text-primary', path: '/oasiscerts/list'}"/>
        <hr class="my-2"/>
        <sidebar-item v-if="isAdmin" :link="{name: 'Bundesländer', icon: 'ni ni-map-big text-primary', path: '/states/edit'}"/>
        <sidebar-item v-if="isAdmin" :link="{name: 'Sozialkonzepte', icon: 'ni ni-books text-primary', path: '/socialconcepts/edit'}"/>
        <sidebar-item v-if="isAdmin" :link="{name: 'Fragebogen-Templates', icon: 'fab fa-wpforms text-primary', path: '/forms/list'}"/>
        <hr class="my-2"/>

        <div v-if="activeLocation !== 0 && isService" align="center" class="mx-auto" @click="limitHover = true" @mouseenter="limitHover = true" @mouseleave="limitHover = false"><h6>Standort ID: {{activeLocation}}</h6>
          <span class="text-muted text-xs ">OASIS Abfragen<br>aktueller Monat</span>
          <limits v-if="limitHover" class="mt-3" :location="activeLocation"></limits>
        </div>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import Limits from "@/views/Locations/limits";
  import NotificationBell from "@/layout/NotificationBell";

  export default {
    components: {
      NotificationBell,
      Limits,
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue',//vue|blue|orange|green|red|primary
        limitHover: false,
        windowWidth: window.innerWidth
      };
    },
    computed: {
      isService () {
        return this.$store.getters['authentication/isService'];
      },
      isOperator () {
        return this.$store.getters['authentication/isOperator'];
      },
      isAdmin () {
        return this.$store.getters['authentication/isAdmin'];
      },
      activeLocation() {
        return this.$store.getters['authentication/location'];
      },
      locationData() {
        return (this.activeLocation > 0 && this.$store.getters['location/isReady'] ) ? this.$store.getters['location/showLocationByIRI']('/api/locations/' + this.activeLocation) : {isTaskAllowed: false, isInspectionTourAllowed: false, isProtocolAllowed: false, isActivityAllowed: false, isPremium: false}
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
